/*
 * @Author: zhengxiaowen 
 * @Date: 2018-10-11 19:21:05 
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2019-02-17 21:26:06
 */
import { fetchTool } from "@/common/index";
import api from "./api";
let fetch = {}

for(let key in api) {
    fetch[key] = (params) => fetchTool.post(api[key], params);
}


// fetchObj.baseLookupTypeService_find = (params) => fetchTool.post(api.baseLookupTypeService_find, params)

export default fetch


// WEBPACK FOOTER //
// ./src/page/devDemo/config/fetch.js